import React, { Fragment, useCallback, useContext, useMemo } from 'react';
import 'survey-react/survey.min.css';
import "./survey.css";
import {
    Alert,
    AlertIcon,
    Box,
    Heading,
    Container,
    Spinner,
    Stack,
} from '@chakra-ui/react';

import ProgressMutation from '../graphql/mutations/updateProgress'
import CreateProgressMutation from '../graphql/mutations/createProgress'
import { useMutation, useQuery } from '@apollo/client'
import * as Survey from "survey-react";
import progressbyId from '../graphql/queries/progressbyId'

import dayjs from 'dayjs';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import sendSurveyByContentId from '../graphql/queries/sendSurveyByContentId';
import createSurvey from '../graphql/mutations/createSurvey';
import AuthContext from '../contexts/AuthContext';
import renderHTML from 'react-render-html';
import draftToHtml from 'draftjs-to-html';


require('dayjs/locale/th')
require('dayjs/locale/en')

var localizedFormat = require('dayjs/plugin/localizedFormat')
dayjs.extend(localizedFormat)

const SendSurveyPage = () => {
    const { contentId } = useParams()
    const location = useLocation()
    const { user } = useContext(AuthContext)
    const userId = user?._id
    const [setUpdateProgress] = useMutation(ProgressMutation)
    const [setCreateProgress] = useMutation(CreateProgressMutation)

    const [setSurveyMutation] = useMutation(createSurvey)
    const { data: Surveys, loading: surveyLoading, error: surveyError } = useQuery(sendSurveyByContentId, {
        variables: {
            _id: contentId,
        },
    })

    const { data: userprogress } = useQuery(progressbyId, {
        variables: {
            content: contentId,
            student: userId
        },
        skip: !userId,
    })

    const progressId = userprogress?.progress?._id
    const canAccessSurvey = Boolean(userId || Surveys?.content?.public === true)
    const surveyQuestions = useMemo(() => {
        const questions = Surveys?.content?.surveyconfig?.surveyQuestions?.questions
        if (Array.isArray(questions)) return questions

        if (typeof questions === 'string') {
            try {
                const parsedQuestions = JSON.parse(questions)
                return Array.isArray(parsedQuestions) ? parsedQuestions : []
            } catch (error) {
                console.error('Invalid survey questions:', error)
            }
        }

        return []
    }, [Surveys])

    const surveyJson = useMemo(() => ({ questions: surveyQuestions }), [surveyQuestions])

    const onCompleteComponent = useCallback(async (survey) => {
        try {
            const { data: surveyResponse } = await setSurveyMutation({
                variables: {
                    content: contentId,
                    student: userId,
                    surveyAnswers: survey?.data,
                    status: 'submit',
                },
            })
            if (surveyResponse && userId) {
                const progressVariables = {
                    content: contentId,
                    student: userId,
                    progress: 100,
                    path: window.location.href,
                }
                const { data: ProgressData } = progressId
                    ? await setUpdateProgress({
                        variables: {
                            _id: progressId,
                            progress: 100
                        }
                    })
                    : await setCreateProgress({
                        variables: progressVariables
                    })
                if (ProgressData) {
                    console.log(ProgressData)
                }
            }
        } catch (error) {
            console.error('Submit survey error:', error)
        }
    }, [contentId, progressId, setCreateProgress, setSurveyMutation, setUpdateProgress, userId])

    const handleConvertHTML = (text) => {
        if (text) {
            return renderHTML(draftToHtml(text))
        }
        return ''
    }

    if (Surveys?.content && !canAccessSurvey) {
        return <Redirect to={{ pathname: '/login', state: { from: location } }} />
    }

    return (
        <Fragment>
            <Box w="100%" px={"20"} minHeight={'90vh'}>
                <Container maxW={'8xl'} mt={2} py={10} as={Stack} spacing={12}>
                    <Box>
                        <Heading size="xl" mt={2}>
                            {Surveys?.content?.name}
                        </Heading>
                        {handleConvertHTML(Surveys?.content?.surveyconfig?.description)}
                        {surveyLoading ? (
                            <Spinner mt={6} />
                        ) : surveyError ? (
                            <Alert status='error' mt={6}>
                                <AlertIcon />
                                ไม่สามารถโหลดแบบประเมินได้
                            </Alert>
                        ) : surveyQuestions.length > 0 && canAccessSurvey ? (
                            <Survey.Survey
                                key={contentId}
                                json={surveyJson}
                                showCompletedPage={true}
                                onComplete={onCompleteComponent}
                                showPreviewBeforeComplete='noPreview'
                                completedHtml='<h1>ขอบคุณที่ตอบแบบสอบถาม</h1>'
                            />
                        ) : Surveys?.content ? (
                            <Alert status='warning' mt={6}>
                                <AlertIcon />
                                แบบประเมินนี้ยังไม่มีคำถาม
                            </Alert>
                        ) : null}
                    </Box>
                </Container>
            </Box>
        </Fragment>
    );
};

export default SendSurveyPage;
